/* eslint no-underscore-dangle: 0, no-param-reassign: 0 */
/**
 * Resalta con el color de cada usuario el bloque que está tocando en una sesión
 * de colaboración. Se instala como side effect al importar; workSpaceClient.js
 * llama a markBlock con un guard por si este módulo no se importó.
 */
import * as Blockly from 'blockly/core';

const DEFAULT_COLOR = '#FFF200';

Blockly.WorkspaceSvg.prototype.userMarkedBlocks = [];
Blockly.WorkspaceSvg.prototype.userMarkers = [];

/**
 * Cada usuario resalta un solo bloque a la vez: antes de marcar uno nuevo,
 * se desmarca el que ese mismo usuario tenía marcado.
 */
Blockly.WorkspaceSvg.prototype.unmarkUserBlocks = function unmarkUserBlocks(userId, id, optState) {
  const blockState = optState === undefined || optState;
  const userBlocks = this.userMarkers.find((u) => u.userId === userId);

  if (!userBlocks) {
    if (blockState) {
      this.userMarkers.push({ userId, blocks: [id] });
    }
    return;
  }

  userBlocks.blocks.forEach((blockId) => {
    const block = blockId ? this.getBlockById(blockId) : null;
    if (block) {
      block.setUsermarker(false);
    }
  });
  userBlocks.blocks = blockState ? [id] : [];
};

Blockly.WorkspaceSvg.prototype.markBlock = function markBlock(userId, id, optState, color = DEFAULT_COLOR) {
  if (optState === undefined) {
    // Sin estado explícito: desmarcar todo (mismo comportamiento que el legacy).
    this.userMarkedBlocks.forEach((block) => block.setUsermarker(false));
    this.userMarkedBlocks.length = 0;
  }

  const block = id ? this.getBlockById(id) : null;
  if (!block) return;

  this.unmarkUserBlocks(userId, id, optState);

  const state = optState === undefined || optState;
  const index = this.userMarkedBlocks.indexOf(block);
  if (!state) {
    if (index !== -1) this.userMarkedBlocks.splice(index, 1);
  } else if (index === -1) {
    this.userMarkedBlocks.push(block);
  }
  block.setUsermarker(state, color);
};

Blockly.BlockSvg.prototype.setUsermarker = function setUsermarker(isHighlightingBlock = true, color = DEFAULT_COLOR) {
  if (!this.rendered) return;
  this.isHighlightingBlock_ = isHighlightingBlock;
  if (this.isHighlightingBlock_ && !this.svgUserMarkerHighlight_) {
    this.svgUserMarkerHighlight_ = this.pathObject.svgPath.cloneNode(true);
    this.svgUserMarkerHighlight_.setAttribute('fill', 'none');
    this.svgUserMarkerHighlight_.setAttribute('stroke', color);
    this.svgUserMarkerHighlight_.setAttribute('stroke-width', '6px');
    this.svgUserMarkerHighlight_.setAttribute('class', 'blocklyUserMarkerHighlight');
    this.getSvgRoot().appendChild(this.svgUserMarkerHighlight_);
  } else if (!this.isHighlightingBlock_ && this.svgUserMarkerHighlight_) {
    this.getSvgRoot().removeChild(this.svgUserMarkerHighlight_);
    this.svgUserMarkerHighlight_ = null;
  }
};

export default Blockly;
